import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Divider, Menu, MenuItem } from '@mui/material';
import { PATHS } from 'AppPaths';
import { Link } from 'util/router';

const LoggedInNavItems = ({ auth }) => {
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
  const isAccountMenuOpen = Boolean(accountMenuAnchorEl);

  const openAccountMenu = (event) => {
    setAccountMenuAnchorEl(event.currentTarget);
  };

  const closeAccountMenu = () => {
    setAccountMenuAnchorEl(null);
  };

  const handleLogout = () => {
    auth.signout();
    closeAccountMenu();
  };

  return (
    <>
      <Button
        color="inherit"
        aria-label="Account Menu"
        aria-controls="account-menu"
        aria-haspopup="true"
        onClick={openAccountMenu}
      >
        Account
        <ExpandMoreIcon />
      </Button>
      <Menu
        id="account-menu"
        open={isAccountMenuOpen}
        anchorEl={accountMenuAnchorEl}
        onClose={closeAccountMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        disableScrollLock={true}
      >
        <MenuItem
          component={Link}
          to={PATHS.SETTINGS('general')}
          onClick={closeAccountMenu}
        >
          Settings
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>Log out</MenuItem>
      </Menu>
    </>
  );
};

export default LoggedInNavItems;
